import consumer from "./consumer"

document.addEventListener('turbo:load', () => {
  const chatroomElement = document.querySelector('[data-chatroom-id]')

  if (chatroomElement) {
    const chatroomId = chatroomElement.dataset.chatroomId

    consumer.subscriptions.create(
      { channel: "ChatroomChannel", id: chatroomId },
      {
        connected() {
        },

        disconnected() {
        },

        received(data) {
        }
      }
    )
  }
})
